import React, { Suspense, lazy } from 'react';
import { withRouter, Switch, Redirect } from 'react-router-dom';
import { useSelector } from "react-redux";

import HorizontalLayout from "../@components/layout/HorizontalLayout";

import { PrivateRoute } from '@components/common/PrivateRoute';
import { PublicRoute } from '@components/common/PublicRoute';

/* loader component for Suspense*/
import PageLoader from '@components/common/PageLoader';
import NovaContaAgrare from 'pages/private/common/ContaAgrare/NovaContaAgrare';
import ContaAgrareEdit from 'pages/private/common/ContaAgrare/cadastro/edit';
import ContaAgrare from 'pages/private/common/ContaAgrare/index';
import LiberarContaAgrare from 'pages/private/common/ContaAgrare/LiberarConta';

// PUBLIC
const LoginPage = lazy(() => import('../pages/public/LoginPage/LoginPage'));
const LoginZendesk = lazy(() => import('../pages/public/LoginZendesk'));
const RegisterPage = lazy(() => import('../pages/public/RegisterPage/RegisterPage'));
const ActivatePage = lazy(() => import('../pages/public/ActivatePage'));
const RecoverPasswordPage = lazy(() => import('../pages/public/RecoverPasswordPage'));
const ResetPasswordPage = lazy(() => import('../pages/public/ResetPasswordPage'));
const ActivatePageNewUserAccount = lazy(() => import('../pages/public/ActivatePageNewUserAccount'));
const TermsOfUse = lazy(() => import('../pages/public/LegalDocuments/TermsOfUse'));
const PrivacyPolicy = lazy(() => import('../pages/public/LegalDocuments/PrivacyPolicy'));
const WebViewAuth = lazy(() => import('../pages/public/WebViewAuth'));

// USUARIO INTRANET
const UsuarioWl = lazy(() => import('../pages/private/intranetWhiteLabel/UsuarioIntranetWl/UsuarioWl'));
const UsuarioWlEdit = lazy(() => import('../pages/private/intranetWhiteLabel/UsuarioIntranetWl/UsuarioWlEdit'));
const UsuarioWlNew = lazy(() => import('../pages/private/intranetWhiteLabel/UsuarioIntranetWl/UsuarioWlNew'));

// PERFIL USUARIO INTRANET
const PerfilWl = lazy(() => import('../pages/private/intranetWhiteLabel/PerfilUsuarioIntranetWl/PerfilWl'));
const PerfilWlNew = lazy(() => import('../pages/private/intranetWhiteLabel/PerfilUsuarioIntranetWl/PerfilWlNew'));
const PerfilWlEdit = lazy(() => import('../pages/private/intranetWhiteLabel/PerfilUsuarioIntranetWl/PerfilWlEdit'));

// PERFIL USUARIO INTRANET
const PartnerWl = lazy(() => import('../pages/private/intranetWhiteLabel/PartnerWl/index'));
const PartnerWlNew = lazy(() => import('../pages/private/intranetWhiteLabel/PartnerWl/cadastro/new'));
const PartnerWlEdit = lazy(() => import('../pages/private/intranetWhiteLabel/PartnerWl/cadastro/edit'));

// GRUPO CONTA PRODUTOR INTRANET
const GrupoContaAgrareWl = lazy(() => import('../pages/private/intranetWhiteLabel/GrupoContaAgrareWl/index'));
const GrupoContaAgrareWlNew = lazy(() => import('../pages/private/intranetWhiteLabel/GrupoContaAgrareWl/cadastro/new'));
const GrupoContaAgrareWlEdit = lazy(() => import('../pages/private/intranetWhiteLabel/GrupoContaAgrareWl/cadastro/edit'));

// CATALAGO PRODUTO INTRANET
const CatalagoProdutoWl = lazy(() => import('../pages/private/intranetWhiteLabel/CatalagoProdutoWl/index'));
const CatalagoProdutoWlNew = lazy(() => import('../pages/private/intranetWhiteLabel/CatalagoProdutoWl/cadastro/new'));
const CatalagoProdutoWlEdit = lazy(() => import('../pages/private/intranetWhiteLabel/CatalagoProdutoWl/cadastro/edit'));

// CORPORATE SEM PERMISSAO
const CorporateSemPermissao = lazy(() => import('../pages/private/intranetWhiteLabel/UsuarioIntranetWl/CorporateSemPermissao'));

const NovaConta = lazy(() => import('../pages/private/common/Onboarding/NovaConta'));
const EndOnboarding = lazy(() => import('../pages/private/postOnboarding'));

// COMMOM
const HomeCorporate = lazy(() => import('../pages/private/home/HomeCorporate'));
const Config = lazy(() => import('../pages/private/config'));
const BreadcrumbCommon = lazy(() => import('../pages/private/common/Breadcrumb'));
const PrimeirosPassos = lazy(() => import('../pages/private/primeirosPassos'));
const NotificationPage = lazy(() => import('../pages/private/common/Notification'));
const NotificationDetails = lazy(() => import('../pages/private/common/Notification/NotificationDetails'));

//SUPORTE
const Suporte = lazy(() => import('../pages/private/common/Suporte/index'));
const SuporteOnFarm = lazy(() => import('../pages/private/common/Suporte/indexOnFarm'));

// CALENDARIO
const Calendario = lazy(() => import('../pages/private/common/Calendario'));

// PROPRIEDADE RURAL
const PropriedadeCadastro = lazy(() => import('../pages/private/common/PropriedadeCadastro'));
const NovaPropriedade = lazy(() => import('../pages/private/common/PropriedadeCadastro/cadastro/new'));
const EditarPropriedade = lazy(() => import('../pages/private/common/PropriedadeCadastro/cadastro/edit'));

// PERFIL USUARIO
const Perfil = lazy(() => import('../pages/private/common/Perfil/Perfil'));
const PerfilNew = lazy(() => import('../pages/private/common/Perfil/PerfilNew'));
const PerfilEdit = lazy(() => import('../pages/private/common/Perfil/PerfilEdit'));

// USUARIO
const Usuario = lazy(() => import('../pages/private/common/Usuario/Usuario'));
const UsuarioNew = lazy(() => import('../pages/private/common/Usuario/UsuarioNew'));
const UsuarioEdit = lazy(() => import('../pages/private/common/Usuario/UsuarioEdit'));
const MeuPerfil = lazy(() => import('../pages/private/common/Usuario/MeuPerfil'));
const SemPermissao = lazy(() => import('../pages/private/common/Usuario/SemPermissao'));
const SemLicenca = lazy(() => import('../pages/private/common/Usuario/SemLicenca'));


// TALHAO
const TalhaoCadastro = lazy(() => import('../pages/private/common/TalhaoCadastro'));
const NovoTalhao = lazy(() => import('../pages/private/common/TalhaoCadastro/cadastro/new'));
const EditarTalhao = lazy(() => import('../pages/private/common/TalhaoCadastro/cadastro/edit'));

// FUNCIONARIO
const FuncionarioCadastro = lazy(() => import('../pages/private/common/FuncionarioCadastro'));
const NovoFuncionario = lazy(() => import('../pages/private/common/FuncionarioCadastro/cadastro/new'));
const EditarFuncionario = lazy(() => import('../pages/private/common/FuncionarioCadastro/cadastro/edit'));

// FUNCIONARIO CARGO
const FuncionarioCargoCadastro = lazy(() => import('../pages/private/common/FuncionarioCargoCadastro'));
const NovoFuncionarioCargo = lazy(() => import('../pages/private/common/FuncionarioCargoCadastro/cadastro/new'));
const EditarFuncionarioCargo = lazy(() => import('../pages/private/common/FuncionarioCargoCadastro/cadastro/edit'));

// UNIDADE MEDIDA
const UnidadeMedidaCadastro = lazy(() => import('../pages/private/common/UnidadeMedidaCadastro'));
const NovoUnidadeMedida = lazy(() => import('../pages/private/common/UnidadeMedidaCadastro/cadastro/new'));
const EditarUnidadeMedida = lazy(() => import('../pages/private/common/UnidadeMedidaCadastro/cadastro/edit'));

const UnidadeMedidaConversaoCadastro = lazy(() => import('../pages/private/common/UnidadeMedidaConversaoCadastro'));
const NovoUnidadeMedidaConversao = lazy(() => import('../pages/private/common/UnidadeMedidaConversaoCadastro/cadastro/new'));
const EditarUnidadeMedidaConversao = lazy(() => import('../pages/private/common/UnidadeMedidaConversaoCadastro/cadastro/edit'));

// PATRIMONIO
const PatrimonioBreadcrumb = lazy(() => import('../pages/private/patrimonio/Breadcrumb'));

const PatrimonioCadastro = lazy(() => import('../pages/private/common/PatrimonioCadastro'));
const NovoPatrimonio = lazy(() => import('../pages/private/common/PatrimonioCadastro/cadastro/new'));
const EditarPatrimonio = lazy(() => import('../pages/private/common/PatrimonioCadastro/cadastro/edit'));

// PATRIMONIO - ABASTECIMENTO
const PatrimonioAbastecimentoCadastro = lazy(() => import('../pages/private/patrimonio/AbastecimentoCadastro'));
const NovoPatrimonioAbastecimento = lazy(() => import('../pages/private/patrimonio/AbastecimentoCadastro/cadastro/new'));
const EditarPatrimonioAbastecimento = lazy(() => import('../pages/private/patrimonio/AbastecimentoCadastro/cadastro/edit'));
const ViewPatrimonioAbastecimento = lazy(() => import('../pages/private/patrimonio/AbastecimentoCadastro/view/view'));

// PATRIMONIO - MANUTENCAO
const PatrimonioManutencaoCadastro = lazy(() => import('../pages/private/patrimonio/ManutencaoCadastro'));
const NovoPatrimonioManutencao = lazy(() => import('../pages/private/patrimonio/ManutencaoCadastro/cadastro/new'));
const EditarPatrimonioManutencao = lazy(() => import('../pages/private/patrimonio/ManutencaoCadastro/cadastro/edit'));
const ViewPatrimonioManutencao = lazy(() => import('../pages/private/patrimonio/ManutencaoCadastro/view/view'));

// PATRIMONIO - ALERTA MANUTENCAO
const PatrimonioAlertaManutencaoCadastro = lazy(() => import('../pages/private/patrimonio/AlertaManutencaoCadastro'));
const NovoPatrimonioAlertaManutencao = lazy(() => import('../pages/private/patrimonio/AlertaManutencaoCadastro/cadastro/new'));
const EditarPatrimonioAlertaManutencao = lazy(() => import('../pages/private/patrimonio/AlertaManutencaoCadastro/cadastro/edit'));
const ViewPatrimonioAlertaManutencao = lazy(() => import('../pages/private/patrimonio/AlertaManutencaoCadastro/view/view'));

// PRODUTO-INSUMO
const ProdutoInsumoCadastro = lazy(() => import('../pages/private/common/ProdutoInsumoCadastro'));
const NovoProdutoInsumo = lazy(() => import('../pages/private/common/ProdutoInsumoCadastro/cadastro/new'));
const EditarProdutoInsumo = lazy(() => import('../pages/private/common/ProdutoInsumoCadastro/cadastro/edit'));

// CLIENTE
const ClienteCadastro = lazy(() => import('../pages/private/common/ClienteCadastro'));
const NovoCliente = lazy(() => import('../pages/private/common/ClienteCadastro/cadastro/new'));
const EditarCliente = lazy(() => import('../pages/private/common/ClienteCadastro/cadastro/edit'));

// FORNECEDOR
const FornecedorCadastro = lazy(() => import('../pages/private/common/FornecedorCadastro'));
const NovoFornecedor = lazy(() => import('../pages/private/common/FornecedorCadastro/cadastro/new'));
const EditarFornecedor = lazy(() => import('../pages/private/common/FornecedorCadastro/cadastro/edit'));

// TRANSPORTADORA
const TransportadoraCadastro = lazy(() => import('../pages/private/common/TransportadoraCadastro'));
const NovaTransportadora = lazy(() => import('../pages/private/common/TransportadoraCadastro/cadastro/new'));
const EditarTransportadora = lazy(() => import('../pages/private/common/TransportadoraCadastro/cadastro/edit'));

// PLUVIOMETRO DIGITAL
const PluviometroDigital = lazy(() => import('../pages/private/common/PluviometroDigital'));
const NovoPluviometroDigital = lazy(() => import('../pages/private/common/PluviometroDigital/cadastro/new'));
const EditarPluviometroDigital = lazy(() => import('../pages/private/common/PluviometroDigital/cadastro/edit'));

// MOTORISTA
const MotoristaCadastro = lazy(() => import('../pages/private/common/MotoristaCadastro'));
const NovoMotorista = lazy(() => import('../pages/private/common/MotoristaCadastro/cadastro/new'));
const EditarMotorista = lazy(() => import('../pages/private/common/MotoristaCadastro/cadastro/edit'));

// VEICULO
const VeiculoCadastro = lazy(() => import('../pages/private/common/VeiculoCadastro'));
const NovoVeiculo = lazy(() => import('../pages/private/common/VeiculoCadastro/cadastro/new'));
const EditarVeiculo = lazy(() => import('../pages/private/common/VeiculoCadastro/cadastro/edit'));

// IDENTIFICADOR
const IdentificadorCadastro = lazy(() => import('../pages/private/common/IdentificadorCadastro'));
const NovoIdentificador = lazy(() => import('../pages/private/common/IdentificadorCadastro/cadastro/new'));
const EditarIdentificador = lazy(() => import('../pages/private/common/IdentificadorCadastro/cadastro/edit'));



// AGRICULTURA
const BreadcrumbAgricCadastros = lazy(() => import('../pages/private/agricultura/Breadcrumb'));
const PainelAgrare = lazy(() => import('../pages/private/common/Dashboard'));

const VisaoFazenda = lazy(() => import('../pages/private/common/Dashboard/VisaoFazenda'));

// SAFRA
const SafraCadastro = lazy(() => import('../pages/private/agricultura/SafraCadastro'));
const NovaSafra = lazy(() => import('../pages/private/agricultura/SafraCadastro/cadastro/new'));
const EditarSafra = lazy(() => import('../pages/private/agricultura/SafraCadastro/cadastro/edit'));

// PROCEDIMENTO
const ProcedimentoCadastro = lazy(() => import('../pages/private/agricultura/ProcedimentoCadastro'));
const NovoProcedimento = lazy(() => import('../pages/private/agricultura/ProcedimentoCadastro/cadastro/new'));
const EditarProcedimento = lazy(() => import('../pages/private/agricultura/ProcedimentoCadastro/cadastro/edit'));

// DESPESA DIRETA
const DespesaDiretaCadastro = lazy(() => import('../pages/private/agricultura/DespesaDiretaCadastro'));
const NovoDespesaDireta = lazy(() => import('../pages/private/agricultura/DespesaDiretaCadastro/cadastro/new'));
const EditarDespesaDireta = lazy(() => import('../pages/private/agricultura/DespesaDiretaCadastro/cadastro/edit'));

// PLANEJAMENTO SAFRA
const Planejamento = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Planejamento'));
const NovoPlanejamento = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Planejamento/cadastro/new'));
const EditarPlanejamento = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Planejamento/cadastro/edit'));
const RealizarPlanejamento = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Planejamento/realizar'));
const ViewPlanejamento = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Planejamento/view/view'));

// ATIVIDADE PLANTIO E MANEJO
const PlantioManejo = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo'));
const NovoPlantioManejo = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo/cadastro/new'));
const EditarPlantioManejo = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo/cadastro/edit'));
const NovoPlantioManejoCustoDireto = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo/custoDireto/new'));
const EditarPlantioManejoCustoDireto = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo/custoDireto/edit'));
const ViewPlantioManejo = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/PlantioManejo/view/view'));

// ATIVIDADE COLHEITA
const Colheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Colheita'));
const NovaColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Colheita/cadastro/new'));
const EditarColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Colheita/cadastro/edit'));
const ViewColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/Colheita/view/view'));

// ROMANEIO COLHEITA
const RomaneioColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/RomaneioColheita'));
const NovoRomaneioColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/RomaneioColheita/cadastro/new'));
const EditarRomaneioColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/RomaneioColheita/cadastro/edit'));
const ViewRomaneioColheita = lazy(() => import('../pages/private/agricultura/AtividadeAgricola/RomaneioColheita/view/view'));

// CULTURA
const CulturaCadastro = lazy(() => import('../pages/private/agricultura/CulturaCadastro'));
const NovaCultura = lazy(() => import('../pages/private/agricultura/CulturaCadastro/cadastro/new'));
const EditarCultura = lazy(() => import('../pages/private/agricultura/CulturaCadastro/cadastro/edit'));

// PRAGAS E DOENÇAS
const PragasDoencas = lazy(() => import('../pages/private/agricultura/PragasDoencas'));
const NovaPragaDoenca = lazy(() => import('../pages/private/agricultura/PragasDoencas/cadastro/new'));
const EditarPragaDoenca = lazy(() => import('../pages/private/agricultura/PragasDoencas/cadastro/edit'));

// CONTROLE DE PRAGAS E DOENÇAS
const ControlePragasDoencas = lazy(() => import('../pages/private/agricultura/ControlePragasDoencas'));
const NovoControlePragaDoenca = lazy(() => import('../pages/private/agricultura/ControlePragasDoencas/cadastro/new'));
const VisualizarControlePragaDoenca = lazy(() => import('../pages/private/agricultura/ControlePragasDoencas/cadastro/view'));
const EditarControlePragaDoenca = lazy(() => import('../pages/private/agricultura/ControlePragasDoencas/cadastro/edit'));

// PRODUTO AGRICOLa
const ProdutoAgricolaCadastro = lazy(() => import('../pages/private/agricultura/ProdutoAgricolaCadastro'));
const NovaProdutoAgricola = lazy(() => import('../pages/private/agricultura/ProdutoAgricolaCadastro/cadastro/new'));
const EditarProdutoAgricola = lazy(() => import('../pages/private/agricultura/ProdutoAgricolaCadastro/cadastro/edit'));

// VENDA PRODUCAO AGRICOLA
const VendaProducaoAgricola = lazy(() => import('../pages/private/agricultura/VendaProducaoAgricola'));
const NovaVendaProducaoAgricola = lazy(() => import('../pages/private/agricultura/VendaProducaoAgricola/cadastro/new'));
const EditarVendaProducaoAgricola = lazy(() => import('../pages/private/agricultura/VendaProducaoAgricola/cadastro/edit'));
const ViewProducaoAgricola = lazy(() => import('../pages/private/agricultura/VendaProducaoAgricola/view/view'));

// RELATORIO ESTOQUE PRODUCAO POR PERIODO
const RelatorioEstoqueProducaoPorPeriodo = lazy(() => import('../pages/private/agricultura/RelatorioEstoqueProducaoPorPeriodo'));

// ESTOQUE IMPLANTACAO PRODUCAO
const ImplantacaoEstoqueProducao = lazy(() => import('../pages/private/agricultura/ImplantacaoEstoqueProducao'));
const NovaImplantacaoEstoqueProducao = lazy(() => import('../pages/private/agricultura/ImplantacaoEstoqueProducao/cadastro/new'));
const EditarImplantacaoEstoqueProducao = lazy(() => import('../pages/private/agricultura/ImplantacaoEstoqueProducao/cadastro/edit'));

// ESTOQUE BAIXA MANUAL PRODUCAO
const BaixarManualEstoqueProducao = lazy(() => import('../pages/private/agricultura/BaixarManualEstoqueProducao'));
const NovaBaixaManualEstoqueProducao = lazy(() => import('../pages/private/agricultura/BaixarManualEstoqueProducao/cadastro/new'));
const EditarBaixaManualEstoqueProducao = lazy(() => import('../pages/private/agricultura/BaixarManualEstoqueProducao/cadastro/edit'));

// ESTOQUE TRANSFERENCIA PRODUCAO
const TransferenciaEstoqueProducao = lazy(() => import('../pages/private/agricultura/TransferenciaEstoqueProducao'));
const NovaTransferenciaEstoqueProducao = lazy(() => import('../pages/private/agricultura/TransferenciaEstoqueProducao/cadastro/new'));
const EditarTransferenciaEstoqueProducao = lazy(() => import('../pages/private/agricultura/TransferenciaEstoqueProducao/cadastro/edit'));

// ESTAGIO-APLICACAO
const EstagioAplicacaoCadastro = lazy(() => import('../pages/private/agricultura/EstagioAplicacao'));
const NovoEstagioAplicacao = lazy(() => import('../pages/private/agricultura/EstagioAplicacao/cadastro/new'));
const EditarEstagioAplicacao = lazy(() => import('../pages/private/agricultura/EstagioAplicacao/cadastro/edit'));


// FINANCEIRO
const BreadcrumbFinanceiro = lazy(() => import('../pages/private/financeiro/Breadcrumb'));

// PLANO DE CONTA GERENCIAL
const PlanoContaCadastro = lazy(() => import('../pages/private/financeiro/PlanoContaCadastro'));
const NovoPlanoConta = lazy(() => import('../pages/private/financeiro/PlanoContaCadastro/cadastro/new'));
const EditarPlanoConta = lazy(() => import('../pages/private/financeiro/PlanoContaCadastro/cadastro/edit'));

// CENTRO DE CUSTO
const CentroCustoCadastro = lazy(() => import('../pages/private/financeiro/CentroCusto'));
const NovoCentroCusto = lazy(() => import('../pages/private/financeiro/CentroCusto/cadastro/new'));
const EditarCentroCusto = lazy(() => import('../pages/private/financeiro/CentroCusto/cadastro/edit'));

// CONTA CAIXA
const ContaCaixaCadastro = lazy(() => import('../pages/private/financeiro/ContaCaixaCadastro'));
const NovaContaCaixa = lazy(() => import('../pages/private/financeiro/ContaCaixaCadastro/cadastro/new'));
const EditarContaCaixa = lazy(() => import('../pages/private/financeiro/ContaCaixaCadastro/cadastro/edit'));

// CONTA BANCO
const ContaBancoCadastro = lazy(() => import('../pages/private/financeiro/ContaBancoCadastro'));
const NovoBanco = lazy(() => import('../pages/private/financeiro/ContaBancoCadastro/cadastro/new'));
const EditarBanco = lazy(() => import('../pages/private/financeiro/ContaBancoCadastro/cadastro/edit'));

// CONTA CARTAO
const ContaCartaoCadastro = lazy(() => import('../pages/private/financeiro/ContaCartaoCadastro'));
const NovoCartao = lazy(() => import('../pages/private/financeiro/ContaCartaoCadastro/cadastro/new'));
const EditarCartao = lazy(() => import('../pages/private/financeiro/ContaCartaoCadastro/cadastro/edit'));

// CONTROLE CONTA CAIXA
const ControleContaCaixa = lazy(() => import('../pages/private/financeiro/ControleContaCaixa'));
const NovoLancamentoControleContaCaixa = lazy(() => import('../pages/private/financeiro/ControleContaCaixa/cadastro/new'));
const EditarLancamentoControleContaCaixa = lazy(() => import('../pages/private/financeiro/ControleContaCaixa/cadastro/edit'));

// CONTROLE CONTA BANCO
const ControleContaBanco = lazy(() => import('../pages/private/financeiro/ControleContaBanco'));
const NovoLancamentoControleContaBanco = lazy(() => import('../pages/private/financeiro/ControleContaBanco/cadastro/new'));
const EditarLancamentoControleContaBanco = lazy(() => import('../pages/private/financeiro/ControleContaBanco/cadastro/edit'));

// CONTROLE CONTA BANCO
const TransferenciaContaBancoCaixa = lazy(() => import('../pages/private/financeiro/TransferenciaContaBancoCaixa'));
const NovaTransferenciaContaBancoCaixa = lazy(() => import('../pages/private/financeiro/TransferenciaContaBancoCaixa/cadastro/new'));
const EditarTransferenciaContaBancoCaixa = lazy(() => import('../pages/private/financeiro/TransferenciaContaBancoCaixa/cadastro/edit'));

// CONCILIAÇÃO BANCÁRIA
const ConciliacaoBancaria = lazy(() => import('../pages/private/financeiro/ConciliacaoBancaria'));
const ConciliacaoExtratos = lazy(() => import('../pages/private/financeiro/ConciliacaoBancaria/Extratos'));
const NovoExtratoOfx = lazy(() => import('../pages/private/financeiro/ConciliacaoBancaria/Extratos/cadastro/new'));

// FLUXO DE CAIXA
const FluxoCaixa = lazy(() => import('../pages/private/financeiro/FluxoCaixa'));

// CONTA PAGAR
const ContaPagar = lazy(() => import('../pages/private/financeiro/ContaPagar'));
const NovoLancamentoContaPagar = lazy(() => import('../pages/private/financeiro/ContaPagar/cadastro/new'));
const EditarLancamentoContaPagar = lazy(() => import('../pages/private/financeiro/ContaPagar/cadastro/edit'));
const ViewLancamentoContaPagar = lazy(() => import('../pages/private/financeiro/ContaPagar/view/view'));

// CONTA PAGAR
const ContaPagarRecorrente = lazy(() => import('../pages/private/financeiro/ContaPagarRecorrente'));
const NovoLancamentoContaPagarRecorrente = lazy(() => import('../pages/private/financeiro/ContaPagarRecorrente/cadastro/new'));
const EditarLancamentoContaPagarRecorrente = lazy(() => import('../pages/private/financeiro/ContaPagarRecorrente/cadastro/edit'));

// CONTA RECEBER
const ContaReceber = lazy(() => import('../pages/private/financeiro/ContaReceber'));
const NovoLancamentoContaReceber = lazy(() => import('../pages/private/financeiro/ContaReceber/cadastro/new'));
const EditarLancamentoContaReceber = lazy(() => import('../pages/private/financeiro/ContaReceber/cadastro/edit'));
const ViewLancamentoContaReceber = lazy(() => import('../pages/private/financeiro/ContaReceber/view/view'));


// ESTOQUE

const BreadcrumbEstoque = lazy(() => import('../pages/private/estoque/Breadcrumb'));

// LOCAL ESTOQUE
const LocalEstoqueCadastro = lazy(() => import('../pages/private/estoque/LocalEstoqueCadastro'));
const NovoLocalEstoque = lazy(() => import('../pages/private/estoque/LocalEstoqueCadastro/cadastro/new'));
const EditarLocalEstoque = lazy(() => import('../pages/private/estoque/LocalEstoqueCadastro/cadastro/edit'));

// ESTOQUE ENTRADA
const EntradaEstoque = lazy(() => import('../pages/private/estoque/EstoqueEntrada'));
const NovaEntradaEstoque = lazy(() => import('../pages/private/estoque/EstoqueEntrada/cadastro/new'));
const EditarEntradaEstoque = lazy(() => import('../pages/private/estoque/EstoqueEntrada/cadastro/edit'));
const ViewEntradaEstoque = lazy(() => import('../pages/private/estoque/EstoqueEntrada/view/view'));

// ESTOQUE IMPLANTACAO
const ImplantacaoEstoque = lazy(() => import('../pages/private/estoque/ImplantacaoEstoque'));
const NovaImplantacaoEstoque = lazy(() => import('../pages/private/estoque/ImplantacaoEstoque/cadastro/new'));
const EditarImplantacaoEstoque = lazy(() => import('../pages/private/estoque/ImplantacaoEstoque/cadastro/edit'));

// ESTOQUE TRANSFERENCIA
const TransferenciaEstoque = lazy(() => import('../pages/private/estoque/TransferenciaEstoque'));
const NovaTransferenciaEstoque = lazy(() => import('../pages/private/estoque/TransferenciaEstoque/cadastro/new'));
const EditarTransferenciaEstoque = lazy(() => import('../pages/private/estoque/TransferenciaEstoque/cadastro/edit'));

// ESTOQUE BAIXA MANUAL
const BaixarManualEstoque = lazy(() => import('../pages/private/estoque/BaixarManualEstoque'));
const NovaBaixaManualEstoque = lazy(() => import('../pages/private/estoque/BaixarManualEstoque/cadastro/new'));
const EditarBaixaManualEstoque = lazy(() => import('../pages/private/estoque/BaixarManualEstoque/cadastro/edit'));

// RELATORIO ESTOQUE ATUAL
const RelatorioEstoqueAtual = lazy(() => import('../pages/private/estoque/RelatorioEstoqueAtual'));

// RELATORIO REPOSICAO ESTOQUE MINIMO
const RelatorioReposicaoEstoqueMinimo = lazy(() => import('../pages/private/estoque/RelatorioReposicaoEstoqueMinimo'));

// RELATORIO ESTOQUE POR PERIODO
const RelatorioEstoquePorPeriodo = lazy(() => import('../pages/private/estoque/RelatorioEstoquePorPeriodo'));

// ESTOQUE IMPORTACAO XML ENTRADA
const ImportacaoXmlEntrada = lazy(() => import('../pages/private/estoque/ImportacaoXmlEntrada'));

// TRIBUTARIO

// NATUREZA OPERACAO
const NaturezaOperacaoCadastro = lazy(() => import('../pages/private/tributario/NaturezaOperacaoCadastro'));
const NovaNaturezaOperacao = lazy(() => import('../pages/private/tributario/NaturezaOperacaoCadastro/cadastro/new'));
const EditarNaturezaOperacao = lazy(() => import('../pages/private/tributario/NaturezaOperacaoCadastro/cadastro/edit'));

// MENSAGEM FISCAL
const MensagemFiscalCadastro = lazy(() => import('../pages/private/tributario/MensagemFiscal'));
const NovaMensagemFiscal = lazy(() => import('../pages/private/tributario/MensagemFiscal/cadastro/new'));
const EditarMensagemFiscal = lazy(() => import('../pages/private/tributario/MensagemFiscal/cadastro/edit'));

// FUNRURAL
const Funrural = lazy(() => import('../pages/private/tributario/Funrural'));

// TABELA TRIBUTARIA
const TabelaTributariaCadastro = lazy(() => import('../pages/private/tributario/TabelaTributaria'));
const NovaTabelaTributaria = lazy(() => import('../pages/private/tributario/TabelaTributaria/cadastro/new'));
const EditarTabelaTributaria = lazy(() => import('../pages/private/tributario/TabelaTributaria/cadastro/edit'));

// CADASTRO EMITENTE
const EmitenteCadastro = lazy(() => import('../pages/private/fiscal/EmitenteCadastro'));
const NovoEmitenteCadastro = lazy(() => import('../pages/private/fiscal/EmitenteCadastro/cadastro/new'));
const EditarEmitenteCadastro = lazy(() => import('../pages/private/fiscal/EmitenteCadastro/cadastro/edit'));

// CADASTRO CERTIFICADO DIGITAL
const CertificaodDigitalCadastro = lazy(() => import('../pages/private/fiscal/CertificadoDigitalCadastro'));
const NovoCertificaodDigital = lazy(() => import('../pages/private/fiscal/CertificadoDigitalCadastro/cadastro/new'));
const EditarCertificaodDigital = lazy(() => import('../pages/private/fiscal/CertificadoDigitalCadastro/cadastro/edit'));

// MONITORAMENTO NFE COMPRA
const MonitoramentoNFeCompra = lazy(() => import('../pages/private/fiscal/MonitoramentoNFeCompra'));

// EMISSAO NFE
const NFeEmissao = lazy(() => import('../pages/private/fiscal/NFeEmissao'));
const NFeEmissaoNew = lazy(() => import('../pages/private/fiscal/NFeEmissao/cadastro/new'));
const NFeEmissaoEdit = lazy(() => import('../pages/private/fiscal/NFeEmissao/cadastro/edit'));
const ViewNFeEmissao = lazy(() => import('../pages/private/fiscal/NFeEmissao/view/view'));

const UsuariosList = lazy(() => import('../pages/private/intranet/usuariosProdutor'));
const UsuariosView = lazy(() => import('../pages/private/intranet/usuariosProdutor/view.jsx'));

const alwaysPublicPages = ['/login-zendesk', '/termos-de-uso', '/politica-de-privacidade', '/webview-auth'];

const listofPages = ['/login', '/register', '/recover'];

const listPrivateNoThemofPages = [
    '/home',
    '/meuPerfil',
    '/suporte',
    '/corporate/contaProdutor',
    '/corporate/contaProdutor/novo',
    '/corporate/contaProdutor/liberar',
    '/corporate/usuarios',
    '/corporate/usuarios/novo',
    '/corporate/perfilAcesso',
    '/corporate/parceiros',
    '/corporate/grupoContaProdutor',
    '/corporate/catalagoInsumos',
    '/corporate/semPermissao',
    '/corporate/usuariosProdutor',
    '/corporate/usuariosProdutor/view',
];

const Routes = ({ location }) => {
    const user = useSelector(state => state.entities.loginReducer?.user);
    const isSuporte = user?.perfil === 'SUPORTE_AGRARE';
    const hasNoScheme = user?.countSchemes === 0;

    const getOnboardingPath = (perfil) => {
      return perfil === 'ESTUDANTE_PESQUISA'
        ? '/conta-estudante'
        : '/nova-conta';
    };

    if (alwaysPublicPages.includes(location.pathname)) {
      return (
        <Suspense fallback={<PageLoader />}>
          <Switch location={location}>
            <PublicRoute path='/login-zendesk' component={LoginZendesk} />
            <PublicRoute path="/termos-de-uso" component={TermsOfUse} />
            <PublicRoute
              path="/politica-de-privacidade"
              component={PrivacyPolicy}
            />
            <PublicRoute path="/webview-auth" component={WebViewAuth} />
          </Switch>
        </Suspense>
      );
    }

    if (user == null) {
        if (listofPages.indexOf(location.pathname) > -1
            || location.pathname.includes('/activate/')
            || location.pathname.includes('/activateUserAccount/')
            || location.pathname.includes('/resetPassword/')) {
            return (
                <Suspense fallback={<PageLoader />}>
                    <Switch location={location}>
                        <PublicRoute path='/login' component={LoginPage} />
                        
                        <PublicRoute path='/register' component={RegisterPage} />
                        <PublicRoute path='/activate/:token' component={ActivatePage} />
                        <PublicRoute path='/recover' component={RecoverPasswordPage} />
                        <PublicRoute path='/resetPassword/:token/:email' component={ResetPasswordPage} />
                        <PublicRoute path='/activateUserAccount/:token/:schema' component={ActivatePageNewUserAccount} />

                        <Redirect to="/login" />
                    </Switch>
                </Suspense>
            )
        } else {
            return (
                <Suspense fallback={<PageLoader />}>
                    <Switch location={location}>
                        <Redirect to="/login" />
                    </Switch>
                </Suspense>
            );
        }
    } else {
        if (hasNoScheme && !isSuporte) {
          return (
            <Suspense fallback={<PageLoader />}>
              <Switch location={location}>
                <PrivateRoute
                  exact
                  path={getOnboardingPath(user?.perfil)}
                  component={NovaConta}
                />
                <Redirect to={getOnboardingPath(user?.perfil)} />
              </Switch>
            </Suspense>
          );
        }

        if (location.pathname.includes('/pos-onboarding')) {
          return (
            <Suspense fallback={<PageLoader />}>
              <Switch location={location}>
                <PrivateRoute
                  exact
                  path="/pos-onboarding"
                  component={EndOnboarding}
                />
              </Switch>
            </Suspense>
          );
        }

        if ((listPrivateNoThemofPages.indexOf(location.pathname) > -1)
            || location.pathname.includes('/corporate/usuariosProdutor/view')
            || location.pathname.includes('/corporate/usuarios/')
            || location.pathname.includes('/corporate/perfilAcesso/')
            || location.pathname.includes('/corporate/parceiros/')
            || location.pathname.includes('/corporate/contaProdutor/')
            || location.pathname.includes('/corporate/grupoContaProdutor/')
            || location.pathname.includes('/corporate/catalagoInsumos/')
            || location.pathname.includes('/corporate/semPermissao/')) {
            return (
                <Suspense fallback={<PageLoader />}>
                    <Switch location={location}>
                        <PrivateRoute exact path='/home' component={HomeCorporate} />
                        <PrivateRoute exact path='/meuPerfil' component={MeuPerfil} />
                        <PrivateRoute exact path='/suporte' component={Suporte} />
                        { (user.perfil === 'SUPORTE_AGRARE') ? (
                            <>
                                <PrivateRoute exact path='/corporate/usuariosProdutor' component={UsuariosList} />
                                <PrivateRoute path='/corporate/usuariosProdutor/view/:id' component={UsuariosView} />
                                <PrivateRoute exact path='/corporate/contaProdutor/novo' component={NovaContaAgrare} />
                                <PrivateRoute exact path='/corporate/contaProdutor' component={ContaAgrare} />
                                <PrivateRoute path='/corporate/contaProdutor/editar/:id' component={ContaAgrareEdit} />
                                <PrivateRoute path='/corporate/contaProdutor/liberar/:id' component={LiberarContaAgrare} />
                                <PrivateRoute exact path='/corporate/usuarios' component={UsuarioWl} />
                                <PrivateRoute path='/corporate/usuarios/editar/:id' component={UsuarioWlEdit} />
                                <PrivateRoute path='/corporate/usuarios/novo' component={UsuarioWlNew} />
                                <PrivateRoute exact path='/corporate/perfilAcesso' component={PerfilWl} />
                                <PrivateRoute path='/corporate/perfilAcesso/novo' component={PerfilWlNew} />
                                <PrivateRoute path='/corporate/perfilAcesso/editar/:id' component={PerfilWlEdit} />
                                <PrivateRoute exact path='/corporate/parceiros' component={PartnerWl} />
                                <PrivateRoute path='/corporate/parceiros/novo' component={PartnerWlNew} />
                                <PrivateRoute path='/corporate/parceiros/editar/:id' component={PartnerWlEdit} />
                                <PrivateRoute exact path='/corporate/grupoContaProdutor' component={GrupoContaAgrareWl} />
                                <PrivateRoute path='/corporate/grupoContaProdutor/novo' component={GrupoContaAgrareWlNew} />
                                <PrivateRoute path='/corporate/grupoContaProdutor/editar/:id' component={GrupoContaAgrareWlEdit} />
                                <PrivateRoute exact path='/corporate/catalagoInsumos' component={CatalagoProdutoWl} />
                                <PrivateRoute path='/corporate/catalagoInsumos/novo' component={CatalagoProdutoWlNew} />
                                <PrivateRoute path='/corporate/catalagoInsumos/editar/:id' component={CatalagoProdutoWlEdit} />
                                <PrivateRoute exact path='/corporate/semPermissao' component={CorporateSemPermissao} />
                            </>
                        ) : (
                            location.pathname.includes('/corporate/') && <Redirect to="/home" />
                        )}
                        
                        {user.perfil === 'SUPORTE_AGRARE' ? (
                            <Redirect to="/corporate/contaProdutor" />
                        ) : (
                            <Redirect to="/home" />
                        )}
                    </Switch>
                </Suspense>
            )
        }

        return (
            <HorizontalLayout>
                <Suspense fallback={<PageLoader />}>
                    <Switch location={location}>

                        <PrivateRoute exact path='/primeirosPassos' component={PrimeirosPassos} />
                        <PrivateRoute exact path='/notifications' component={NotificationPage} />
                        <PrivateRoute exact path='/notifications/:id' component={NotificationDetails} />

                        <PrivateRoute exact path='/centralAjuda' component={SuporteOnFarm} />

                        <PrivateRoute exact path='/dashboard' component={PainelAgrare} />

                        <PrivateRoute exact path='/mapa' component={VisaoFazenda} />

                        <PrivateRoute exact path='/config' component={Config} />

                        <PrivateRoute exact path='/semPermissao' component={SemPermissao} />

                        <PrivateRoute exact path='/noLicense' component={SemLicenca} />

                        <PrivateRoute exact path='/cadastros' component={BreadcrumbCommon} />

                        <PrivateRoute exact path='/agricultura' component={BreadcrumbAgricCadastros} />

                        <PrivateRoute exact path='/calendario' component={Calendario} />

                        <PrivateRoute exact path='/minhasFazendas' component={PropriedadeCadastro} />
                        <PrivateRoute exact path='/minhasFazendas/novo' component={NovaPropriedade} />
                        <PrivateRoute path='/minhasFazendas/editar/:id' component={EditarPropriedade} />

                        <PrivateRoute exact path='/seguranca/perfilUsuario' component={Perfil} />
                        <PrivateRoute exact path='/seguranca/perfilUsuario/novo' component={PerfilNew} />
                        <PrivateRoute path='/seguranca/perfilUsuario/editar/:id' component={PerfilEdit} />

                        <PrivateRoute exact path='/seguranca/usuario' component={Usuario} />
                        <PrivateRoute path='/seguranca/usuario/novo' component={UsuarioNew} />
                        <PrivateRoute path='/seguranca/usuario/editar/:idUserAuth' component={UsuarioEdit} />

                        <PrivateRoute exact path='/talhaoCadastro' component={TalhaoCadastro} />
                        <PrivateRoute exact path='/talhaoCadastro/novo' component={NovoTalhao} />
                        <PrivateRoute path='/talhaoCadastro/editar/:id' component={EditarTalhao} />

                        <PrivateRoute exact path='/funcionarioCadastro' component={FuncionarioCadastro} />
                        <PrivateRoute exact path='/funcionarioCadastro/novo' component={NovoFuncionario} />
                        <PrivateRoute path='/funcionarioCadastro/editar/:id' component={EditarFuncionario} />

                        <PrivateRoute exact path='/funcionarioCargoCadastro' component={FuncionarioCargoCadastro} />
                        <PrivateRoute exact path='/funcionarioCargoCadastro/novo' component={NovoFuncionarioCargo} />
                        <PrivateRoute path='/funcionarioCargoCadastro/editar/:id' component={EditarFuncionarioCargo} />

                        <PrivateRoute exact path='/patrimonio' component={PatrimonioBreadcrumb} />

                        <PrivateRoute exact path='/patrimonioCadastro' component={PatrimonioCadastro} />
                        <PrivateRoute exact path='/patrimonioCadastro/novo' component={NovoPatrimonio} />
                        <PrivateRoute path='/patrimonioCadastro/editar/:id' component={EditarPatrimonio} />

                        <PrivateRoute exact path='/patrimonio/abastecimento' component={PatrimonioAbastecimentoCadastro} />
                        <PrivateRoute exact path='/patrimonio/abastecimento/novo' component={NovoPatrimonioAbastecimento} />
                        <PrivateRoute path='/patrimonio/abastecimento/editar/:id' component={EditarPatrimonioAbastecimento} />
                        <PrivateRoute path='/patrimonio/abastecimento/view/:id' component={ViewPatrimonioAbastecimento} />

                        <PrivateRoute exact path='/patrimonio/manutencao' component={PatrimonioManutencaoCadastro} />
                        <PrivateRoute exact path='/patrimonio/manutencao/novo' component={NovoPatrimonioManutencao} />
                        <PrivateRoute path='/patrimonio/manutencao/editar/:id' component={EditarPatrimonioManutencao} />
                        <PrivateRoute path='/patrimonio/manutencao/view/:id' component={ViewPatrimonioManutencao} />

                        <PrivateRoute exact path='/patrimonio/manutencao/alerta' component={PatrimonioAlertaManutencaoCadastro} />
                        <PrivateRoute exact path='/patrimonio/manutencao/alerta/novo' component={NovoPatrimonioAlertaManutencao} />
                        <PrivateRoute path='/patrimonio/manutencao/alerta/editar/:id' component={EditarPatrimonioAlertaManutencao} />
                        <PrivateRoute path='/patrimonio/manutencao/alerta/view/:id' component={ViewPatrimonioAlertaManutencao} />

                        <PrivateRoute exact path='/insumoCadastro' component={ProdutoInsumoCadastro} />
                        <PrivateRoute exact path='/insumoCadastro/novo' component={NovoProdutoInsumo} />
                        <PrivateRoute path='/insumoCadastro/editar/:id' component={EditarProdutoInsumo} />

                        <PrivateRoute exact path='/clienteCadastro' component={ClienteCadastro} />
                        <PrivateRoute exact path='/clienteCadastro/novo' component={NovoCliente} />
                        <PrivateRoute path='/clienteCadastro/editar/:id' component={EditarCliente} />

                        <PrivateRoute exact path='/fornecedorCadastro' component={FornecedorCadastro} />
                        <PrivateRoute exact path='/fornecedorCadastro/novo' component={NovoFornecedor} />
                        <PrivateRoute path='/fornecedorCadastro/editar/:id' component={EditarFornecedor} />

                        <PrivateRoute exact path='/transportadoraCadastro' component={TransportadoraCadastro} />
                        <PrivateRoute exact path='/transportadoraCadastro/novo' component={NovaTransportadora} />
                        <PrivateRoute path='/transportadoraCadastro/editar/:id' component={EditarTransportadora} />

                        <PrivateRoute exact path='/pluviometroDigital' component={PluviometroDigital} />
                        <PrivateRoute exact path='/pluviometroDigital/novo' component={NovoPluviometroDigital} />
                        <PrivateRoute path='/pluviometroDigital/editar/:id' component={EditarPluviometroDigital} />

                        <PrivateRoute exact path='/motoristaCadastro' component={MotoristaCadastro} />
                        <PrivateRoute exact path='/motoristaCadastro/novo' component={NovoMotorista} />
                        <PrivateRoute path='/motoristaCadastro/editar/:id' component={EditarMotorista} />

                        <PrivateRoute exact path='/veiculoCadastro' component={VeiculoCadastro} />
                        <PrivateRoute exact path='/veiculoCadastro/novo' component={NovoVeiculo} />
                        <PrivateRoute path='/veiculoCadastro/editar/:id' component={EditarVeiculo} />

                        <PrivateRoute exact path='/identificadorCadastro' component={IdentificadorCadastro} />
                        <PrivateRoute exact path='/identificadorCadastro/novo' component={NovoIdentificador} />
                        <PrivateRoute path='/identificadorCadastro/editar/:id' component={EditarIdentificador} />

                        <PrivateRoute exact path='/unidadeMedidaCadastro' component={UnidadeMedidaCadastro} />
                        <PrivateRoute exact path='/unidadeMedidaCadastro/novo' component={NovoUnidadeMedida} />
                        <PrivateRoute path='/unidadeMedidaCadastro/editar/:id' component={EditarUnidadeMedida} />

                        <PrivateRoute exact path='/unidadeMedidaConversaoCadastro' component={UnidadeMedidaConversaoCadastro} />
                        <PrivateRoute exact path='/unidadeMedidaConversaoCadastro/novo' component={NovoUnidadeMedidaConversao} />
                        <PrivateRoute path='/unidadeMedidaConversaoCadastro/editar/:id' component={EditarUnidadeMedidaConversao} />

                        <PrivateRoute exact path='/safraCadastro' component={SafraCadastro} />
                        <PrivateRoute exact path='/safraCadastro/novo' component={NovaSafra} />
                        <PrivateRoute path='/safraCadastro/editar/:id' component={EditarSafra} />

                        <PrivateRoute exact path='/procedimentoCadastro' component={ProcedimentoCadastro} />
                        <PrivateRoute exact path='/procedimentoCadastro/novo' component={NovoProcedimento} />
                        <PrivateRoute path='/procedimentoCadastro/editar/:id' component={EditarProcedimento} />

                        <PrivateRoute exact path='/despesaDiretaCadastro' component={DespesaDiretaCadastro} />
                        <PrivateRoute exact path='/despesaDiretaCadastro/novo' component={NovoDespesaDireta} />
                        <PrivateRoute path='/despesaDiretaCadastro/editar/:id' component={EditarDespesaDireta} />

                        <PrivateRoute exact path='/agricultura/planejamento' component={Planejamento} />
                        <PrivateRoute exact path='/agricultura/planejamento/novo' component={NovoPlanejamento} />
                        <PrivateRoute path='/agricultura/planejamento/editar/:id' component={EditarPlanejamento} />
                        <PrivateRoute exact path='/agricultura/planejamento/realizar' component={RealizarPlanejamento} />
                        <PrivateRoute path='/agricultura/planejamento/view/:id' component={ViewPlanejamento} />

                        <PrivateRoute exact path='/agricultura/execucao' component={PlantioManejo} />
                        <PrivateRoute exact path='/agricultura/execucao/novo' component={NovoPlantioManejo} />
                        <PrivateRoute path='/agricultura/execucao/editar/:id' component={EditarPlantioManejo} />
                        <PrivateRoute exact path='/agricultura/execucao/custoDireto/novo' component={NovoPlantioManejoCustoDireto} />
                        <PrivateRoute path='/agricultura/execucao/custoDireto/editar/:id' component={EditarPlantioManejoCustoDireto} />
                        <PrivateRoute path='/agricultura/execucao/view/:id' component={ViewPlantioManejo} />

                        <PrivateRoute exact path='/agricultura/colheita' component={Colheita} />
                        <PrivateRoute exact path='/agricultura/colheita/novo' component={NovaColheita} />
                        <PrivateRoute path='/agricultura/colheita/editar/:id' component={EditarColheita} />
                        <PrivateRoute path='/agricultura/colheita/view/:id' component={ViewColheita} />

                        <PrivateRoute exact path='/agricultura/romaneioColheita' component={RomaneioColheita} />
                        <PrivateRoute exact path='/agricultura/romaneioColheita/novo' component={NovoRomaneioColheita} />
                        <PrivateRoute path='/agricultura/romaneioColheita/editar/:id' component={EditarRomaneioColheita} />
                        <PrivateRoute path='/agricultura/romaneioColheita/view/:id' component={ViewRomaneioColheita} />

                        <PrivateRoute exact path='/culturaCadastro' component={CulturaCadastro} />
                        <PrivateRoute exact path='/culturaCadastro/novo' component={NovaCultura} />
                        <PrivateRoute path='/culturaCadastro/editar/:id' component={EditarCultura} />

                        <PrivateRoute exact path='/pragas-doencas' component={PragasDoencas} />
                        <PrivateRoute exact path='/pragas-doencas/novo' component={NovaPragaDoenca} />
                        <PrivateRoute path='/pragas-doencas/editar/:id' component={EditarPragaDoenca} />

                        <PrivateRoute exact path='/agricultura/controle-pragas-doencas' component={ControlePragasDoencas} />
                        <PrivateRoute exact path='/agricultura/controle-pragas-doencas/novo' component={NovoControlePragaDoenca} />
                        <PrivateRoute exact path='/agricultura/controle-pragas-doencas/view/:id' component={VisualizarControlePragaDoenca} />
                        <PrivateRoute exact path='/agricultura/controle-pragas-doencas/view' component={VisualizarControlePragaDoenca} />
                        <PrivateRoute path='/agricultura/controle-pragas-doencas/:id' component={EditarControlePragaDoenca} />

                        <PrivateRoute exact path='/produtoAgricolaCadastro' component={ProdutoAgricolaCadastro} />
                        <PrivateRoute exact path='/produtoAgricolaCadastro/novo' component={NovaProdutoAgricola} />
                        <PrivateRoute path='/produtoAgricolaCadastro/editar/:id' component={EditarProdutoAgricola} />

                        <PrivateRoute exact path='/agricultura/producao/venda' component={VendaProducaoAgricola} />
                        <PrivateRoute exact path='/agricultura/producao/venda/novo' component={NovaVendaProducaoAgricola} />
                        <PrivateRoute path='/agricultura/producao/venda/editar/:id' component={EditarVendaProducaoAgricola} />
                        <PrivateRoute path='/agricultura/producao/view/:id' component={ViewProducaoAgricola} />

                        <PrivateRoute exact path='/agricultura/producao/relatorioEstoque' component={RelatorioEstoqueProducaoPorPeriodo} />

                        <PrivateRoute exact path='/agricultura/producao/implantacao' component={ImplantacaoEstoqueProducao} />
                        <PrivateRoute exact path='/agricultura/producao/implantacao/novo' component={NovaImplantacaoEstoqueProducao} />
                        <PrivateRoute path='/agricultura/producao/implantacao/editar/:id' component={EditarImplantacaoEstoqueProducao} />

                        <PrivateRoute exact path='/agricultura/producao/baixaManual' component={BaixarManualEstoqueProducao} />
                        <PrivateRoute exact path='/agricultura/producao/baixaManual/novo' component={NovaBaixaManualEstoqueProducao} />
                        <PrivateRoute path='/agricultura/producao/baixaManual/editar/:id' component={EditarBaixaManualEstoqueProducao} />

                        <PrivateRoute exact path='/agricultura/producao/transferencia' component={TransferenciaEstoqueProducao} />
                        <PrivateRoute exact path='/agricultura/producao/transferencia/novo' component={NovaTransferenciaEstoqueProducao} />
                        <PrivateRoute path='/agricultura/producao/transferencia/editar/:id' component={EditarTransferenciaEstoqueProducao} />

                        <PrivateRoute exact path='/agricultura/aplicacao/estagio' component={EstagioAplicacaoCadastro} />
                        <PrivateRoute exact path='/agricultura/aplicacao/estagio/novo' component={NovoEstagioAplicacao} />
                        <PrivateRoute path='/agricultura/aplicacao/estagio/editar/:id' component={EditarEstagioAplicacao} />

                        <PrivateRoute exact path='/financeiro' component={BreadcrumbFinanceiro} />

                        <PrivateRoute exact path='/financeiro/planoContaCadastro' component={PlanoContaCadastro} />
                        <PrivateRoute exact path='/financeiro/planoContaCadastro/novo' component={NovoPlanoConta} />
                        <PrivateRoute path='/financeiro/planoContaCadastro/editar/:id' component={EditarPlanoConta} />

                        <PrivateRoute exact path='/financeiro/centroCustoCadastro' component={CentroCustoCadastro} />
                        <PrivateRoute exact path='/financeiro/centroCustoCadastro/novo' component={NovoCentroCusto} />
                        <PrivateRoute path='/financeiro/centroCustoCadastro/editar/:id' component={EditarCentroCusto} />

                        <PrivateRoute exact path='/financeiro/contaCaixaCadastro' component={ContaCaixaCadastro} />
                        <PrivateRoute exact path='/financeiro/contaCaixaCadastro/novo' component={NovaContaCaixa} />
                        <PrivateRoute path='/financeiro/contaCaixaCadastro/editar/:id' component={EditarContaCaixa} />

                        <PrivateRoute exact path='/financeiro/contaBancoCadastro' component={ContaBancoCadastro} />
                        <PrivateRoute exact path='/financeiro/contaBancoCadastro/novo' component={NovoBanco} />
                        <PrivateRoute path='/financeiro/contaBancoCadastro/editar/:id' component={EditarBanco} />

                        <PrivateRoute exact path='/financeiro/contaCartaoCadastro' component={ContaCartaoCadastro} />
                        <PrivateRoute exact path='/financeiro/contaCartaoCadastro/novo' component={NovoCartao} />
                        <PrivateRoute path='/financeiro/contaCartaoCadastro/editar/:id' component={EditarCartao} />

                        <PrivateRoute exact path='/financeiro/movimentacoesCaixa' component={ControleContaCaixa} />
                        <PrivateRoute exact path='/financeiro/movimentacoesCaixa/novo' component={NovoLancamentoControleContaCaixa} />
                        <PrivateRoute path='/financeiro/movimentacoesCaixa/editar/:id' component={EditarLancamentoControleContaCaixa} />

                        <PrivateRoute exact path='/financeiro/movimentacoesBancarias' component={ControleContaBanco} />
                        <PrivateRoute exact path='/financeiro/movimentacoesBancarias/novo' component={NovoLancamentoControleContaBanco} />
                        <PrivateRoute exact path='/financeiro/movimentacoesBancarias/conciliacao' component={ConciliacaoBancaria} />
                        <PrivateRoute exact path='/financeiro/movimentacoesBancarias/conciliacao/extratos' component={ConciliacaoExtratos} />
                        <PrivateRoute exact path='/financeiro/movimentacoesBancarias/conciliacao/extratos/novo' component={NovoExtratoOfx} />
                        <PrivateRoute path='/financeiro/movimentacoesBancarias/editar/:id' component={EditarLancamentoControleContaBanco} />

                        <PrivateRoute exact path='/financeiro/transferenciaContaBancoCaixa' component={TransferenciaContaBancoCaixa} />
                        <PrivateRoute exact path='/financeiro/transferenciaContaBancoCaixa/novo' component={NovaTransferenciaContaBancoCaixa} />
                        <PrivateRoute path='/financeiro/transferenciaContaBancoCaixa/editar/:id' component={EditarTransferenciaContaBancoCaixa} />

                        <PrivateRoute exact path='/financeiro/fluxoCaixa' component={FluxoCaixa} />

                        <PrivateRoute exact path='/financeiro/contaPagar' component={ContaPagar} />
                        <PrivateRoute exact path='/financeiro/contaPagar/novo' component={NovoLancamentoContaPagar} />
                        <PrivateRoute path='/financeiro/contaPagar/editar/:id' component={EditarLancamentoContaPagar} />
                        <PrivateRoute path='/financeiro/contaPagar/view/:id' component={ViewLancamentoContaPagar} />

                        <PrivateRoute exact path='/financeiro/contaPagar/recorrente' component={ContaPagarRecorrente} />
                        <PrivateRoute exact path='/financeiro/contaPagar/recorrente/novo' component={NovoLancamentoContaPagarRecorrente} />
                        <PrivateRoute path='/financeiro/contaPagar/recorrente/editar/:id' component={EditarLancamentoContaPagarRecorrente} />

                        <PrivateRoute exact path='/financeiro/contaReceber' component={ContaReceber} />
                        <PrivateRoute exact path='/financeiro/contaReceber/novo' component={NovoLancamentoContaReceber} />
                        <PrivateRoute path='/financeiro/contaReceber/editar/:id' component={EditarLancamentoContaReceber} />
                        <PrivateRoute path='/financeiro/contaReceber/view/:id' component={ViewLancamentoContaReceber} />

                        <PrivateRoute exact path='/estoque' component={BreadcrumbEstoque} />

                        <PrivateRoute exact path='/estoque/localEstoqueCadastro' component={LocalEstoqueCadastro} />
                        <PrivateRoute exact path='/estoque/localEstoqueCadastro/novo' component={NovoLocalEstoque} />
                        <PrivateRoute path='/estoque/localEstoqueCadastro/editar/:id' component={EditarLocalEstoque} />

                        <PrivateRoute exact path='/financeiro/entradaNota' component={EntradaEstoque} />
                        <PrivateRoute exact path='/financeiro/entradaNota/novo' component={NovaEntradaEstoque} />
                        <PrivateRoute path='/financeiro/entradaNota/editar/:id' component={EditarEntradaEstoque} />
                        <PrivateRoute path='/financeiro/entradaNota/view/:id' component={ViewEntradaEstoque} />

                        <PrivateRoute path='/fiscal/entrada/importacaoXml' component={ImportacaoXmlEntrada} />

                        <PrivateRoute exact path='/estoque/implantacao' component={ImplantacaoEstoque} />
                        <PrivateRoute exact path='/estoque/implantacao/novo' component={NovaImplantacaoEstoque} />
                        <PrivateRoute path='/estoque/implantacao/editar/:id' component={EditarImplantacaoEstoque} />

                        <PrivateRoute exact path='/estoque/transferencia' component={TransferenciaEstoque} />
                        <PrivateRoute exact path='/estoque/transferencia/novo' component={NovaTransferenciaEstoque} />
                        <PrivateRoute path='/estoque/transferencia/editar/:id' component={EditarTransferenciaEstoque} />

                        <PrivateRoute exact path='/estoque/baixarManual' component={BaixarManualEstoque} />
                        <PrivateRoute exact path='/estoque/baixarManual/novo' component={NovaBaixaManualEstoque} />
                        <PrivateRoute path='/estoque/baixarManual/editar/:id' component={EditarBaixaManualEstoque} />

                        <PrivateRoute exact path='/estoque/movimentacao/estoqueAtual' component={RelatorioEstoqueAtual} />
                        <PrivateRoute exact path='/estoque/movimentacao/reposicaoEstoqueMinimo' component={RelatorioReposicaoEstoqueMinimo} />
                        <PrivateRoute exact path='/estoque/movimentacao/estoquePorPeriodo' component={RelatorioEstoquePorPeriodo} />

                        <PrivateRoute exact path='/fiscal/naturezaOperacaoCadastro' component={NaturezaOperacaoCadastro} />
                        <PrivateRoute exact path='/fiscal/naturezaOperacaoCadastro/novo' component={NovaNaturezaOperacao} />
                        <PrivateRoute path='/fiscal/naturezaOperacaoCadastro/editar/:id' component={EditarNaturezaOperacao} />

                        <PrivateRoute exact path='/fiscal/inscricaoFiscal' component={EmitenteCadastro} />
                        <PrivateRoute exact path='/fiscal/inscricaoFiscal/novo' component={NovoEmitenteCadastro} />
                        <PrivateRoute path='/fiscal/inscricaoFiscal/editar/:id' component={EditarEmitenteCadastro} />

                        <PrivateRoute exact path='/fiscal/certificadoDigital' component={CertificaodDigitalCadastro} />
                        <PrivateRoute exact path='/fiscal/certificadoDigital/novo' component={NovoCertificaodDigital} />
                        <PrivateRoute path='/fiscal/certificadoDigital/editar/:id' component={EditarCertificaodDigital} />

                        <PrivateRoute exact path='/fiscal/monitoramento/nfeSefaz' component={MonitoramentoNFeCompra} />

                        <PrivateRoute exact path='/fiscal/nfe/emissao' component={NFeEmissao} />
                        <PrivateRoute exact path='/fiscal/nfe/emissao/novo' component={NFeEmissaoNew} />
                        <PrivateRoute path='/fiscal/nfe/emissao/editar/:id' component={NFeEmissaoEdit} />
                        <PrivateRoute path='/fiscal/nfe/emissao/view/:id' component={ViewNFeEmissao} />

                        <PrivateRoute exact path='/fiscal/mensagemFiscal' component={MensagemFiscalCadastro} />
                        <PrivateRoute exact path='/fiscal/mensagemFiscal/novo' component={NovaMensagemFiscal} />
                        <PrivateRoute path='/fiscal/mensagemFiscal/editar/:id' component={EditarMensagemFiscal} />

                        <PrivateRoute exact path='/fiscal/funrural' component={Funrural} />

                        <PrivateRoute exact path='/fiscal/tabelaTributaria' component={TabelaTributariaCadastro} />
                        <PrivateRoute exact path='/fiscal/tabelaTributaria/novo' component={NovaTabelaTributaria} />
                        <PrivateRoute path='/fiscal/tabelaTributaria/editar/:id' component={EditarTabelaTributaria} />

                        <Redirect to='/dashboard' />
                    </Switch>
                </Suspense>
            </HorizontalLayout>
        );
    }
}

export default withRouter(Routes);
